import React from 'react';

import {BlockEditorPane} from 'insights/analytics-dashboards/details/view-state/ScreenState';
import ToggleExpandButton from 'ui-library/buttons/ToggleExpandButton';

export default function AnalyticsBlockEditorPaneToggleExpandButton({
  className,
  expandedPane,
  onToggleExpandPane,
  pane,
}: {
  className?: string;
  expandedPane: BlockEditorPane | null;
  onToggleExpandPane: (pane: BlockEditorPane, newIsExpanded: boolean) => void;
  pane: BlockEditorPane;
}): JSX.Element {
  return (
    <ToggleExpandButton
      className={className}
      isExpanded={expandedPane === pane}
      onChange={(newIsExpanded: boolean) => {
        onToggleExpandPane(pane, newIsExpanded);
      }}
    />
  );
}
